import { useDropdown } from 'components/UI/V3/Dropdown/DropdownContext';
import React from 'react';

interface DropdownTriggerProps {
    children: React.ReactNode;
    className?: string;
    disabled?: boolean;
}

export const DropdownTrigger: React.FC<DropdownTriggerProps> = ({ children, className, disabled = false }) => {
    const { setOpen, triggerRef } = useDropdown();

    const handleClick = () => {
        if (!disabled) {
            setOpen(true);
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (!disabled) {
                setOpen(true);
            }
        }
    };

    return (
        <div
            ref={triggerRef as React.RefObject<HTMLDivElement>}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            className={className}
            role="button"
            tabIndex={disabled ? -1 : 0}
            aria-expanded={undefined}
            aria-haspopup="dialog"
            aria-disabled={disabled}
        >
            {children}
        </div>
    );
};
